// removed by extract-text-webpack-plugin
module.exports = {"container":"_3-SrZ","link":"_1uYN2","term":"_3RaHk"};


//////////////////
// WEBPACK FOOTER
// ./app/components/no-search-results/no-search-results.scss
// module id = 1784
// module chunks = 0